import './product-support-recall.scss';

class ProductSupportRecall {
    constructor (element) {
        this.$productSupportRecall = element;
        this.$$clearInputValue = this.$productSupportRecall.querySelectorAll('[data-support-recall-clear-input]');
        this.$showSecondInput = this.$productSupportRecall.querySelector('[data-support-recall="show-second-input"]');
        this.$$productCheckTab = this.$productSupportRecall.querySelectorAll('[data-product-check-tab]');
        this.$showFallbackInput = this.$productSupportRecall.querySelector('[data-product-check-show-fallback-input]');
        this.$$productCheckForms = this.$productSupportRecall.querySelectorAll('form');

        this.digit7MinValue = 2740000;
        this.digit12MinValue = 274000000000;

        this.initialize();
    }

    initialize () {
        this.setEvents();
        this.checkSizes();
    }

    setEvents () {
        if (this.$$clearInputValue.length > 0) {
            this.$$clearInputValue.forEach($clearInputValue => {
                $clearInputValue.onclick = () => {
                    const $inputField = this.$productSupportRecall.querySelector(`[data-support-recall-input="${$clearInputValue.dataset.supportRecallClearInput}"]`);

                    if ($inputField) {
                        $inputField.value = '';
                    }
                };
            });
        }

        if (this.$showFallbackInput) {
            this.$showFallbackInput.onclick = () => {
                if (this.$showFallbackInput.getAttribute('aria-expanded') === 'false') {
                    this.$showFallbackInput.setAttribute('aria-expanded', 'true');
                } else {
                    this.$showFallbackInput.setAttribute('aria-expanded', 'false');
                }
            };
        }

        if (this.$showSecondInput) {
            const $secondInputFieldset = this.$productSupportRecall.querySelector('#idform-second');
            const $secondInput = $secondInputFieldset?.querySelector('input');

            if ($secondInput) {
                $secondInput.setAttribute('disabled', 'disabled');
            }

            this.$showSecondInput.onclick = () => {
                if ($secondInputFieldset && $secondInput) {
                    $secondInputFieldset.classList.remove('is--hidden');
                    $secondInput.removeAttribute('disabled');

                    setTimeout(() => {
                        $secondInput.focus();
                        this.$showSecondInput.parentElement.classList.add('is--hidden');
                    }, 200);
                }
            };
        }

        if (this.$$productCheckTab.length > 0) {
            this.$$productCheckTab.forEach($productCheckTab => {
                $productCheckTab.onclick = () => {
                    if ($productCheckTab.getAttribute('aria-expanded') === 'false') {
                        this.$$productCheckTab.forEach($productCheckTab => {
                            $productCheckTab.setAttribute('aria-expanded', 'false');
                        });

                        $productCheckTab.setAttribute('aria-expanded', 'true');
                    }
                };
            });
        }

        if (this.$$productCheckForms.length > 0) {
            this.$$productCheckForms.forEach($productCheckForm => {
                const $$allInputs = $productCheckForm.querySelectorAll('input');
                const $submitButton = $productCheckForm.querySelector('button[type="submit"]');

                if ($submitButton) {
                    $submitButton.classList.add('is--secondary');
                }

                $$allInputs.forEach($input => {
                    $input.onchange = () => {
                        if ($submitButton) {
                            $submitButton.classList.toggle('is--secondary', !this.validateForm($$allInputs));
                        }
                    };
                });

                $productCheckForm.onsubmit = (e) => {
                    e.preventDefault();

                    $$allInputs.forEach($input => {
                        if ($input.hasAttribute('disabled')) {
                            return;
                        }

                        const $validationErrorMessage = $input.parentElement?.parentElement?.querySelector('[data-form-validation-failed]');

                        if ($validationErrorMessage) {
                            $validationErrorMessage.dataset.formValidationFailed = !this.validateInput($input.value, this.minValueFor($input));
                        }
                    });

                    if (this.validateForm($$allInputs)) {
                        $productCheckForm.submit();
                    }
                };
            });
        }
    }

    minValueFor ($input) {
        return $input.dataset.supportRecallInput === 'id' ? this.digit12MinValue : this.digit7MinValue;
    }

    validateForm ($$inputs) {
        let valid = true;

        $$inputs.forEach($input => {
            if (!$input.hasAttribute('disabled')) {
                valid = this.validateInput($input.value, this.minValueFor($input)) && valid;
            }
        });

        return valid;
    }

    checkSizes () {
        if (!window.mediaMatch[1024].matches) {
            this.handleTabActivationByViewport(false);
        }

        window.mediaMatch[1024].addEventListener('change', (match) => {
            this.handleTabActivationByViewport(match.matches);
        });
    }

    handleTabActivationByViewport (desktop = false) {
        if (this.$$productCheckTab.length > 0) {
            this.$$productCheckTab.forEach($productCheckTab => {
                if (desktop === true) {
                    $productCheckTab.setAttribute('aria-expanded', $productCheckTab.dataset.ariaExpanded);
                } else {
                    $productCheckTab.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }

    validateInput (inputValue, minValue) {
        return Number(inputValue) >= minValue;
    }
}

export { ProductSupportRecall };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$productSupportRecall = $context.querySelectorAll('[data-product-support-recall="root"]');

    if ($$productSupportRecall.length > 0) {
        $$productSupportRecall.forEach(($productSupportRecall) => {
            const productSupportRecall = new ProductSupportRecall($productSupportRecall); // eslint-disable-line
        });
    }
});
